export const generateTitle = (uniName: string, subdirectory: string): string => {
	let title;

	//check name length so title doesn't exceed recommended SEO length
	const length = uniName?.length;

	switch (subdirectory) {
		case 'postgraduate':
			if (length < 22) {
				title = `${uniName} Postgraduate | Ranking & Locations`;
			} else if (length === 22) {
				title = `${uniName} Postgraduate | Rating & Locations`;
			} else if (length > 22 && length < 34) {
				title = `${uniName} Postgraduate Locations`;
			} else if (length === 34) {
				title = `${uniName} Postgraduate Openings`;
			} else if (length === 35) {
				title = `${uniName} Postgraduate Spaces`;
			} else {
				title = `${uniName} Postgraduate`;
			}
			break;

		case 'clearing':
			title = `${uniName} Clearing | Degree Course Vacancies`;
			break;

		case 'reviews':
			if (length < 26) {
				title = `${uniName} Reviews | Ranks & Testimonies`;
			} else if (length >= 26 && length <= 40) {
				title = `${uniName} Reviews & Ratings`;
			} else {
				title = `${uniName} Reviews`;
			}

			break;
		default:
			title = `${uniName} | Ranking & Locations`;
	}

	return title;
};

export const generateDescription = (uniName: string, subdirectory: string): string => {
	let description;

	switch (subdirectory) {
		//cases for URL universities/:page
		case 'postgraduate':
			description = `Find everything about ${uniName} Postgraduate Courses at University Compare. Read the latest information on rankings, reviews, accommodation and more.`;
			break;
		case 'clearing':
			description = `Find everything about ${uniName} Clearing at University Compare. Read the latest information on rankings, reviews, testimonies and more.`;
			break;
		case 'reviews':
			description = `Find everything about ${uniName} reviews at University Compare. Read the latest information on rankings, reviews, accommodation and more.`;
			break;
		default:
			description = `Find everything you need to know about ${uniName} at University Compare. Read the latest information on rankings, reviews, accommodation and more.`;
	}

	return description;
};
